import React from 'react';
import './InfoMessage.scss';

export type InfoMessageProps = {
  message: string;
  icon?: string;
  className?: string;
};

const InfoMessage: React.FC<InfoMessageProps> = ({ 
  message, 
  icon = 'info',
  className = ''
}) => {
  return (
    <div className={`info-message ${className}`.trim()}>
      <i className="material-icons">{icon}</i>
      <span dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

export default InfoMessage;
